const FRENCH_LOCALE = 'fr';

export function getCouponOffLabelHtml(label: string) {
  return `<span data-coupon-off-label>${label}</span>`;
}

export function getCouponOffLabelTextClassName(locale: string, isWap: boolean) {
  if (locale !== FRENCH_LOCALE) return '';

  return isWap ? '!text-[12px]' : '!text-[16px]';
}

export function getCouponOffLabelContainerClassName(locale: string, isWap: boolean) {
  if (locale !== FRENCH_LOCALE) return '';

  return isWap
    ? '[&_[data-coupon-off-label]]:!text-[12px]'
    : '[&_[data-coupon-off-label]]:!text-[16px]';
}
